/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { BooleanClaimValue } from './BooleanClaimValue';
import { DateClaimValue } from './DateClaimValue';
import { DateTimeClaimValue } from './DateTimeClaimValue';
import { FileClaimValue } from './FileClaimValue';
import { LinkClaimValue } from './LinkClaimValue';
import { NumberClaimValue } from './NumberClaimValue';
import { StringClaimValue } from './StringClaimValue';

export const CredentialClaimValue: core.serialization.Schema<
    serializers.CredentialClaimValue.Raw,
    Truvity.CredentialClaimValue
> = core.serialization
    .union('kind', {
        ARRAY: core.serialization.lazyObject(() => serializers.ArrayClaimValue),
        BOOLEAN: BooleanClaimValue,
        DATE: DateClaimValue,
        DATETIME: DateTimeClaimValue,
        FILE: FileClaimValue,
        LINK: LinkClaimValue,
        NUMBER: NumberClaimValue,
        STRING: StringClaimValue,
        STRUCT: core.serialization.lazyObject(() => serializers.StructClaimValue),
    })
    .transform<Truvity.CredentialClaimValue>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace CredentialClaimValue {
    export type Raw =
        | CredentialClaimValue.Array
        | CredentialClaimValue.Boolean
        | CredentialClaimValue.Date
        | CredentialClaimValue.Datetime
        | CredentialClaimValue.File
        | CredentialClaimValue.Link
        | CredentialClaimValue.Number
        | CredentialClaimValue.String
        | CredentialClaimValue.Struct;

    export interface Array extends serializers.ArrayClaimValue.Raw {
        kind: 'ARRAY';
    }

    export interface Boolean extends BooleanClaimValue.Raw {
        kind: 'BOOLEAN';
    }

    export interface Date extends DateClaimValue.Raw {
        kind: 'DATE';
    }

    export interface Datetime extends DateTimeClaimValue.Raw {
        kind: 'DATETIME';
    }

    export interface File extends FileClaimValue.Raw {
        kind: 'FILE';
    }

    export interface Link extends LinkClaimValue.Raw {
        kind: 'LINK';
    }

    export interface Number extends NumberClaimValue.Raw {
        kind: 'NUMBER';
    }

    export interface String extends StringClaimValue.Raw {
        kind: 'STRING';
    }

    export interface Struct extends serializers.StructClaimValue.Raw {
        kind: 'STRUCT';
    }
}
